import React from 'react';
import { connect, useSelector } from 'react-redux';
import get from 'lodash/get';

import 'react-perfect-scrollbar/dist/css/styles.css';
import { layoutChanged } from 'Redux/thunks/global.thunks';
import { setIntoLocalStorage } from 'Internals/local-storage';

import { findDefaultUrl, findSubscription } from '../utils/subscription.utils';
import { StorageKeys } from '../constants/storageKeys';

import { useNavBarCollapseState } from '../hooks/useNavBarCollapseState.hook';
import { useNavBarLinks } from '../hooks/useNavBarLinks';

import { StatusBarContainer } from './StatusBar.container';

import { NavBar } from '../components/navbar/NavBar.view';
import { SubscriptionAvatarContainer } from './SubscriptionAvatar.container';

import type { AppDispatch, RootState } from '../types/state.types';

const NavBarContainer: React.FC<{
  layoutChange: () => void;
  subId: string;
  location: {
    query?: Record<string, any>;
  };
}> = (props) => {
  const { subId } = props;
  const connected = useSelector((state: RootState) => state.subscription.connected);
  const sub = useSelector((state: RootState) =>
    findSubscription(state.subscriptions)(state.subscription.id)
  );
  const customConnectionURL = useSelector((state: RootState) => state.customConnectionURLs[subId]);
  const url = useSelector((state: RootState) => state.subscription.url);
  const navBarMenuItemGroups = useNavBarLinks(subId, connected);

  const initialCollapsed = get(props, ['location', 'query', 'collapsed'], false);
  const [collapsed, setCollapsed] = useNavBarCollapseState(subId, initialCollapsed);

  const handleToggle = () => {
    setIntoLocalStorage(StorageKeys.navbar, subId, !collapsed);
    setCollapsed(!collapsed);
  };

  return (
    <NavBar
      collapsed={collapsed}
      navBarMenuItemGroups={navBarMenuItemGroups}
      primaryItem={
        sub && (
          <SubscriptionAvatarContainer
            connectionUrl={url}
            customConnectionURL={customConnectionURL}
            name={sub.name}
            subId={sub.id}
            isDefaultUrl={findDefaultUrl(sub) === url}
            nowrap
            shouldDisplayRestoreLinkButton={true}
          />
        )
      }
      handleToggle={handleToggle}
      statusBar={
        collapsed ? (
          <StatusBarContainer collapsed={true} />
        ) : (
          <StatusBarContainer collapsed={false} />
        )
      }
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  subId: state.subscription.id,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  layoutChange: () => dispatch(layoutChanged()),
});

const Connected = connect(mapStateToProps, mapDispatchToProps)(NavBarContainer);

export { Connected as NavBarContainer };
